import React from "react";
// import LazyLoad from "react-lazyload";

import Button from "../Button/Button";

import "./ImageCard.css";

const imageCard = (props) => {
  let classes = "ImageCard";
  if (props.horizontal) {
    classes += " horizontal";
  }
  return (
    <div className={classes}>
      <div className="imageContainer">
        <img src={props.img_src} alt={props.img_alt} />
      </div>
      <div className="imageInfo">{props.children}</div>
      {props.horizontal ? null : (
        <Button to={props.to} buttonType="Black" size="sm">
          {props.buttonText}
        </Button>
      )}
    </div>
  );
};

export default imageCard;
